module.exports = __webpack_public_path__ + "static/media/32-1.9a61ab2f.mp3";